module.exports = __webpack_public_path__ + "static/media/bruce5.06c4c0b5.mp3";